module.exports = __webpack_public_path__ + "img/Couple.12effbfd.svg";